import { gql } from '@apollo/client';

export const typename = 'UserMeta';

export const UserMeta = gql`
  fragment UserMeta on UserMeta {
    onboardingSteps
  }
`;
